<template>
  
    <v-container>
        <Header />
        <v-dialog persistent content-class="innerExPan" v-model="Loaderdialog"  id="innerExPan" >
        <v-row no-gutters>
          <v-col cols="12" sm="12" style="text-align:center">
            <img  :src="require('@/assets/images/loader.svg')"  />
          </v-col>
        </v-row>
      </v-dialog>
     <v-snackbar Bottom :timeout="timeout" :color="SnackbarColor"  v-model="snackbar">
        {{ SnackbarMessege }}
      </v-snackbar> 


      <v-row >
        <v-col cols="12" >
          <v-card
            style="background-image: linear-gradient(to bottom right, #07a, #cdcdc4);"
            dark
          >
            <div style=" text-align:center;    color: #000;">
              <h4>{{ItemObject.ItemName}}</h4>
              <h4>{{ItemObject.ItemNameArabic}}</h4>
           <label for=""> Branch : {{BranchCode}}</label>
            </div>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
               
                <v-card-title
                  class=""
                >{{ItemObject.Category}} </v-card-title>
  
                <v-card-subtitle
                
                >{{ItemObject.SubCategory}}</v-card-subtitle>
                <div
                  style=" text-align:left;    color:#fff;    padding-left: 15px;" 
                >
                 
                  <h4 @click="GetAlternativeUnits(ItemObject.ItemId)">
                    <small style="color:#000">Retail Rate</small>
                    {{FormatewithDecimalPlacesNew(ItemObject.RetailRateFinal)}}&nbsp;&nbsp;<small style="color:#f3d921">{{Currency}}</small>
                  </h4>
                  <h4 @click="GetGodownStockList(ItemObject.ItemId,CurrentStock)">
                    <small style="color:#000">Stock</small>
                    {{CurrentStock}}
                  </h4>
                </div>
  
                <v-card-text class="text--primary">
                  <div>
                    <v-icon style="color: #000;">mdi-barcode</v-icon>
                    <v-title style="color:#fff;font-size: 14px;"
                      >&nbsp;&nbsp;{{ItemObject.Barcode}}</v-title
                    >
                  </div>
                </v-card-text>
              </div>
              <div >
                <!-- <sub>{{slides[0].FileURL}}</sub> -->
                <v-avatar class="ma-3" size="125" tile  @click="DetailAttachmentModal=true">
                <v-img  :src="FileURL" ></v-img>
              </v-avatar>
              </div>
           

            </div>
          </v-card>
          <v-card class="mx-auto" style="box-shadow:none;">
          <v-row>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:5px;"
              >
                Brand <br /><b>{{ItemObject.Brand}}</b>
              </v-card-subtitle>
            </v-col>
  
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:5px;"
              >
                Item Code <br /><b>{{ItemObject.ItemCode}}</b>
              </v-card-subtitle>
            </v-col>
  
             <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:5px;"
                @click="OpenUpdateCategoryModal()"
              >
                Category <br /><b style="color:orange">{{ItemObject.Category}}</b>
              </v-card-subtitle>
            </v-col>
           
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:5px;"
                @click="OpenUpdateCategoryModal()"

              >
                SubCategory <br /><b style="color:orange">{{ItemObject.SubCategory}}</b>
              </v-card-subtitle>
            </v-col>
         
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
              Unit<br /><b
                  >{{ ItemObject.Unit }}
                  <span v-if="ItemObject.Conversion != 1"
                    >(1 × {{ ItemObject.Conversion }})</span
                  ></b
                >
              </v-card-subtitle>
            </v-col>

            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                @click="OpenUpdateShelfNoModal()"
                style="padding-bottom:0px;padding-top:3px;"
              >
                ShelfNo <br /><b style="color:orange">{{ItemObject.ShelfNo}}</b>
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Reorder Level <br /><b>{{ ItemObject.ReorderLevel }}</b>
              </v-card-subtitle>
            </v-col>

            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Reorder Quantity <br /><b>{{ ItemObject.ReorderQty }}</b>
              </v-card-subtitle>
           
            </v-col>

            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Discount <br /><b>{{FormatewithDecimalPlacesNew(Discountamnt)}}</b>
              </v-card-subtitle>
         
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
                  <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Discount Perc <br /><b>{{FormatewithDecimalPlacesDisc(ItemObject.DiscPerc )}} %</b>
              </v-card-subtitle>
            </v-col>

            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
                 <v-card-subtitle
                
                @click="OpenRetailModalEx()"
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;color:#000"
              >
                Retail Rate <span style="font-size: 10px;">(Excluding Tax & Discount)</span>
                
                <br /><b style="color:orange"
                  >{{FormatewithDecimalPlacesNew(ItemObject.RetailRate)}}
                  <small style="color:black">{{Currency}}</small></b
                >
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
             
                @click="OpenRetailModal()"
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;color:#000"
              >
                Retail Rate 
             
                <br /><b style="color:orange"
                  >{{FormatewithDecimalPlacesNew(ItemObject.RetailRateFinal)}}<small style="color:black"> {{Currency}}</small></b
                >
              </v-card-subtitle>
            </v-col>
            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Made In <br /><b style="color:orange">{{ItemObject.MadeIn}}</b>
              </v-card-subtitle>
            </v-col>

            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;" v-if="(ShowCost===true || ShowCost==='true') && HideItemCostDetails === false">
              <v-card-subtitle
               
                @click="OpenUpdateCostModal()"
                color="orange"
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;color:#000"
              >
                Cost 
              
                <br /><b style="color:orange;"
                  >{{FormatewithDecimalPlacesNew(ItemObject.AltCost)}}<small style="color:black"> {{Currency}}</small></b
                >
              </v-card-subtitle>
            </v-col>
               <v-col cols="6" style="padding-bottom:0px;padding-top:0px;" v-if="ShowSupplier===true || ShowSupplier==='true'">
              <v-card-subtitle
             
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;color:#000"
              >
                Supplier <br /><b 
                  >{{ItemObject.Supplier}}</b
                >
              </v-card-subtitle>
            </v-col>


            <v-col cols="6" style="padding-bottom:0px;padding-top:0px;">
              <v-card-subtitle
                class="pb-0"
                style="padding-bottom:0px;padding-top:3px;"
              >
                Tax <br /><b
                  >{{FormatewithDecimalPlacesNew(Taxamount)}}({{FormatewithDecimalPlacesDisc(ItemObject.TaxPerc)}})%</b
                >
              </v-card-subtitle>
            </v-col>
          </v-row>
          <v-row  >
             <v-col cols="12" class="text-center">
            <v-btn color="defualt" @click="Print_">
              <v-icon dark> mdi-printer </v-icon>
            </v-btn>
          </v-col>
          </v-row>
        </v-card>
   
        </v-col>
      </v-row >
      <v-dialog v-model="UpdateCategoryModal" persistent width="600">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:16px;text-align:center"
          >Update Category and Sub Category</v-card-title
        >

        <v-card-text style="padding-bottom: 0px;">
        
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px;margin-bottom: -16px;padding-top: 10px;">
             
              <v-combobox
              v-model="Category"
              :items="CategoryOptions"
          label="Category"
       
          outlined
          dense
           @change="GetSubCategory($event,true)"
        ></v-combobox>
            </v-col>
            <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px;padding-top: 10px;margin-bottom: -10px;">
             
             <v-combobox
            v-model="SubCategory"
              :items="SubCategoryOptions"
         label="Sub Category"
      
         outlined
         dense
          
       ></v-combobox>
           </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="UpdateCategoryModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
            @click="UpdateSubCategoryByBarcode()"
            style="background-color:#2E7D32;color:#FFF"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="UpdateShelfNoModal" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Update ShelfNo</v-card-title
        >

        <v-card-text style="padding-bottom: 0px;">
            
          <v-row no-gutters>
          <v-col cols="12" sm="12" md="12" style="padding-bottom: 20px;">
              <label for="usr"
                >Existing ShelfNo :
                <big style="color:#000;"
                  >{{ItemObject.ShelfNo}}
                  </big
                ></label
              >
            </v-col>
          </v-row>
        
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" style="padding-bottom: 0px;">
              <v-text-field
                v-model="ShelfNo"
                label="ShelfNo"
                autofocus
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="UpdateShelfNoModal= false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
            @click="UpdateShelfNo()"
            style="background-color:#2E7D32;color:#FFF"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="RetailModalEx" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:16px;text-align:center"
          >Update Retail Rate (Excluding tax)</v-card-title
        >

        <v-card-text style="padding-bottom: 0px;">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <label for="usr"
                >Existing Price :
                <big style="color:#000;"
                  >{{FormatewithDecimalPlacesNew(ItemObject.RetailRate)}}
                  <small>{{Currency}}</small></big
                ></label
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
               v-model="RetailRateExcTax"
                label="Retail Rate (Excluding Tax & Discount)"
                placeholder=""
                autofocus
                type="number"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="RetailModalEx = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
           @click="UpdateRateExcTax()"
            style="background-color:#2E7D32;color:#FFF"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="RetailModal" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Update Retail Rate</v-card-title
        >

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label for="usr"
                >Existing Price :
                <big style="color:#000;"
                  >{{FormatewithDecimalPlacesNew(ItemObject.RetailRateFinal)}}
                  <small>OMR</small></big
                ></label
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="RetailRateFinal"
                label="Enter Retail Rate"
                placeholder=""
                autofocus
                outlined
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="RetailModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
          @click="UpdateRateFinal()"
            small
           
            style="background-color:#2E7D32;color:#FFF"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="UpdateCostModal" persistent width="500">
      <v-card>
        <v-card-title
          style="color:rgb(0 99 145);font-size:17px;text-align:center"
          >Update Cost</v-card-title
        >

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <label for="usr"
                >Existing Price :
                <big style="color:#000;"
                  >{{FormatewithDecimalPlacesNew(ItemObject.AltCost)}}
                  <small>{{ Currency }}</small></big
                ></label
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                type="number"
             v-model="Cost"
                label="Enter Cost"
                placeholder=""
                autofocus
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions hidden>
          <v-spacer></v-spacer>
          <v-btn
            small
            @click="UpdateCostModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            Cancel
          </v-btn>

          <v-btn
            small
        @click="UpdateCost()"
            style="background-color:#2E7D32;color:#FFF"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- GodownStockModalstart -->

 <v-dialog v-model="GodownStockModal" persistent max-width="600" class="checkgodown" style="overflow-y: none !important">
         <v-card
    class="mx-auto"

    outlined
  >
<v-row no-gutters style="    font-size: 13px;"  >
      <v-col cols="12" sm="12" class="text-center" style="padding-top: 4px; padding-bottom: 4px;">
   <b style="text-align:center !important; text-transform:uppercase;">Godown Stock (MB)</b>
      </v-col>
</v-row>
<v-row no-gutters style="    font-size: 13px;"  >
      <v-col cols="12" sm="12" class="text-center" style="    padding-top: 0px;
    padding-bottom: 4px;
    margin-top: -5px;
    font-size: 12px;">
   <span style="color: #2196f3"><b>{{ItemObject.ItemCode}}-{{ItemObject.ItemName}}</b></span>
      </v-col>
</v-row>
 <v-row no-gutters style="    font-size: 10px;padding: 5px;border-bottom: 1px dashed #000;background: #cfcfcf4a;"  >
      <v-col cols="6" sm="6" class="text-left">
    Godown
        </v-col>
      <v-col cols="6" sm="6"  class="text-right">
     Stock
      </v-col>
    </v-row>
     <v-row class="setmaxrownew" no-gutters style=" font-size: 10px;text-align: left;padding: 0px;  overflow:scroll;overflow-x: hidden;"  >
       <v-expansion-panels >

    <v-expansion-panel v-for="(item,i) in GodownStockList"  :key="i" class="ma-0" v-touch:tap="touchHandler" >
       <!-- ----- -->
     <v-expansion-panel-header expand-icon="" >

       <v-row>
       <v-col cols="6" sm="6" class="text-left" style="padding: 0px !important; ">

      <b>{{item.Godown}}</b>
      </v-col>
       <v-col cols="6" sm="6" class="text-right" style="padding: 0px !important; ">

   <b>{{item.Stock}} </b>
      </v-col>

      </v-row>

      </v-expansion-panel-header>
    </v-expansion-panel>
  </v-expansion-panels>
    </v-row>
    <v-divider></v-divider>
   <v-row style="margin:-10px">
        <v-col cols="6" md="6" lg="6" style="text-align:left;padding-top:22px;padding-bottom:22px;padding-left: 12px;">
         
              <v-btn
              small

              style="background-color:#2E7D32;color:#FFF;min-width: 60px !important"
             @click="GodownStockModal=false"
            >
              OK
            </v-btn>

        </v-col>
        <v-col cols="6" md="6" lg="6" style="    text-align: right;
    padding-top: 22px;
    padding-bottom: 22px;
    color: rgb(0, 150, 199);
    padding-right: 22px;
">

          <span style="color:rgb(0 150 199)">Total Stock : <b>{{TotalStock}}</b></span>

        </v-col>
        </v-row>
   

  </v-card>

    </v-dialog>

<!-- GodownStockModalends -->
    <v-dialog v-model="PriceGroupmodal" persistent width="500">
      <v-card>
    

        <v-card-text style="padding: 0px;">
         
   <v-expansion-panels>

    <v-expansion-panel
      v-for="(item,i) in 1"
      :key="i"
      style="padding-left: 10px;"
    >
      <v-expansion-panel-header    style="text-align:center !important;min-height: 24px !important;" expand-icon="" >
          <v-row >
           <v-col cols="10" sm="10" style="padding-left: 0px !important; text-align: left !important;padding-top: 10px;">
       <b style="text-align:center !important; text-transform:uppercase;font-size:12px;color:#007bff;">Price Details</b>
      </v-col>
      <v-col cols="2" sm="2" style="padding: 0px !important; text-align: right !important;padding-top: 5px;">
        <v-icon @click="PriceGroupmodal=false" style="color: green;">mdi-close-box</v-icon>

      </v-col>
      </v-row>
        </v-expansion-panel-header>
    </v-expansion-panel>
  </v-expansion-panels >

     <v-card-actions style="background:#007bff;padding: 1px;">  </v-card-actions>


     <v-row no-gutters style="    font-size: 10px;padding: 5px; background: #343a402e;"  >
      <v-col cols="9" sm="9" class="text-left" style="padding-left: 5px;" >
       <label>Unit</label> 
      </v-col>
          <v-col cols="3" sm="3" class="text-right" style="padding-right: 12px;">
<label>Retail Rate</label> 
      </v-col>

    </v-row>

       <v-expansion-panels >

    <v-expansion-panel v-for="(item,i) in AlternateUnits"  :key="i" class="ma-0" v-touch:tap="touchHandler" >
       <!-- ----- -->
     <v-expansion-panel-header expand-icon=""  style="min-height:35px !important;font-size:10px!important">

       <v-row >
       <v-col cols="9" sm="9"  style="padding-left: 0px; " >

   <b >{{item.Unit}}</b> <b v-if="i>0">({{item.Conversion}} {{AlternateUnits[0].Unit }} )</b>
      </v-col>

       <v-col cols="3" sm="3" style="padding-right: 0px !important; text-align:right">
<label>{{FormatewithDecimalPlacesNew(item.RetailRate)}}</label>
      </v-col>
      </v-row>


      </v-expansion-panel-header>
    </v-expansion-panel>
  </v-expansion-panels>


        </v-card-text>
      </v-card>

    </v-dialog>
    <v-dialog v-model="AttachmentModal" persistent max-width="600">
      <v-card style="border-radius: 0px !important;">
         <v-toolbar dark color="#1976D2">
          <v-btn style=" height: 30px;width: 30px" icon dark @click="AttachmentModal=false">
            <v-icon >mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title style="padding-right: 7px !important;">Item image</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-toolbar-items >
        <v-icon style="padding-right:10px;font-size:20px !important" @click="AddItemImage()" v-if="AttachmentEditId === -1">mdi-content-save</v-icon>
        <v-icon style="padding-right:10px;font-size:20px !important" @click="DownloadItemImage()"  v-if="AttachmentId > -1">mdi-download</v-icon>
        <v-icon style="padding-right:10px;font-size:20px !important"   @click="ClearItemImage()">mdi-eraser</v-icon>
         <v-icon style="padding-right:10px;font-size:20px !important"  @click="DeleteItemImage()" v-if="AttachmentEditId > -1">mdi-delete</v-icon>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" style="padding-top:22px !important">
               <div style="text-align:center"  >
               <img :src="imagePURL" @click="choosefile1" class="blue-grey lighten-4 rounded elevation-3" aspect-ratio="1"  style="width:100%; height:350px;   border: 1px solid #0003;text-align:center;" >
              <input
                type="file"
                id="my_file1"
                style="display: none;padding-top:5px"
                @change="handleImageUpload"
                accept="image/*"
                name="filename"
             

              /> 

            <!-- </v-avatar> -->


            </div>
            </v-col>
          </v-row>
       
        </v-card-text>
      </v-card>
   </v-dialog>
      <v-dialog v-model="DetailAttachmentModal" persistent max-width="600">
      <v-card style="border-radius: 0px !important;">
         <v-toolbar dark color="#1976D2">
          <v-btn style=" height: 30px;width: 30px" icon dark @click="DetailAttachmentModal = false">
            <v-icon >mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title style="padding-right: 7px !important;">Item image</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-toolbar-items >
        <v-icon style="padding-right:10px;font-size:20px !important" @click="OpenItemImageModal()">mdi-plus</v-icon>
     
        <!--  <v-icon style="padding-right:10px;font-size:20px !important" >mdi-delete</v-icon> -->
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="padding-right: 8px;
    padding-left: 5px;">
          <v-row no-gutters>
    <v-col cols="12" style="margin-bottom: -17px;">

        <div class="cover-container"  style="margin-left:0px !important;text-align: center;
    margin-top: 0px;padding-top:0px !important;padding-right:0px" >
           
             <div class="cover-item" v-for="(item,i) in Attachments" :key="i" style="text-align:center;box-shadow:none;padding-top:0px;margin-right:14px">
                <div @click = "EditItemImage(item,i)"  class="cover-item "  style="box-shadow: darkgray;padding-top: 0px !important; padding-bottom: 2px;border-radius: 5px;margin-right:16px;    width: 100px;
    height: 100px;">
    <img :src="item.FileURL"  class="blue-grey lighten-4 rounded elevation-3" aspect-ratio="1" style="width:100px; height:100px;   border: 1px solid #0003;padding-left:1px "  >

            </div>
          
            
             </div>

               <!-- END PANEL -->

    </div>
    </v-col>
    </v-row>
       
        </v-card-text>
      </v-card>
   </v-dialog>
   
 
     <v-dialog v-model="DeleteItemImageModal" persistent width="300">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" style="padding-top: 45px;">
              <span style="font-size: 20px;">Do you want to delete?</span>
            </v-col>
            <v-col cols="12">
            <v-divider></v-divider>
            </v-col>
            <v-col cols="6" style="text-align: center;">
              <v-btn
            small
            @click="DeleteModal = false"
            style="background-color:#FB8C00;color:#FFF"
          >
            No
          </v-btn>
              </v-col>
              <v-col cols="6" style="text-align: center;">
                <v-btn
            small
            @click="ExcecuteDeleteItem()"
            style="background-color:#2E7D32;color:#FFF"
          >
            Yes
          </v-btn>
              </v-col>

          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  
     
    </v-container>
  </template>
  <script>
import Header from "../Pages/Header.vue";
import axios from "axios";
  export default {
    components: {
      Header
    },
    data() {
      return {
        FileURL:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL_nkjk3ZfgDytXi0IAHbpW1PnkEf8TpGwsQ2FnEzoWLc7_Z5VFQnN86GJX1drBJh7ysY&usqp=CAU",
        UpdateCategoryModal:false,
        UpdateShelfNoModal:false,
        RetailModalEx:false,
        RetailModal:false,
        UpdateCostModal:false,
    snackbar: false,
    SnackbarMessege: '',
    SnackbarColor:'green',
    timeout: 2000,
    ItemObject:"",
    bURL : localStorage.getItem('BaseURL'),
    Currency:localStorage.getItem('Currency'),
    DecimalPlaces : localStorage.getItem('symbol'),
    Discountamnt : 0,
    Taxamount:0,
    ShowCost : localStorage.getItem('ShowCost'),
    HideItemCostDetails : false,
    ShowSupplier : localStorage.getItem('ShowSupplier'),
    RetailRateExcTax : '',
    RetailRateFinal:'',
    Cost:'',
    ShelfNo:'',
    Category:"",
    CategoryOptions:[],
    SubCategory:"",
    SubCategoryObject:[],
    SubCategoryOptions:[],
    Loaderdialog:false,
    PriceGroupId :  localStorage.getItem("PriceGroupId")?localStorage.getItem("PriceGroupId"):0,
    BranchCodeOptions:JSON.parse(localStorage.getItem('Branches')),
    BranchCode:localStorage.getItem('SystemBranch'),
    IsMultiBranch:false,
    CurrentStock:0,
    isCreatePermission : false,
    isReadPermission : false,
    isDeletePermission : false,
    isUpdatePermission :false,
    GodownStockModal:false,
    PriceGroupmodal:false,
    AlternateUnits : [],
    GodownStockList : [],
    TotalStock:0,
    imagePURL: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL_nkjk3ZfgDytXi0IAHbpW1PnkEf8TpGwsQ2FnEzoWLc7_Z5VFQnN86GJX1drBJh7ysY&usqp=CAU',
    AttachmentModal:false,
    DetailAttachmentModal:false,
    DeleteItemImageModal:false,
    IsNativeFlutterApp:false,
    headers : {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('Token')
              },
    AttachmentEditId : -1
      };
     
    },
    created() {
     
    },
    mounted() {
      this.Token = localStorage.getItem('Token')
      if (this.Token === "" || this.Token === null || this.Token === undefined ) 
       {
        this.$router.push("login");
       }
       this.IsNativeFlutterApp = localStorage.getItem("IsNativeFlutterApp");
        if (this.IsNativeFlutterApp === "true" || this.IsNativeFlutterApp === true)
        {
          this.IsNativeFlutterApp = true
        }
        else
        {
          this.IsNativeFlutterApp = false
        }

       if(this.BranchCodeOptions.length > 1)
       {
          this.IsMultiBranch = true
       }
       this.SetPermission()
       this.GetCategory()
       this.GetRoleSettings()


       //Redirecting based on display time
       this.Display_time = localStorage.getItem('Display_time')
       this.Display_time = parseInt(this.Display_time)
       if(isNaN(this.Display_time) === true)
       {
        this.Display_time = 0
       }
       if(this.Display_time > 0)
       {
        this.Time = this.Display_time * 1000
        /*  setTimeout(() => {
          setTimeout(this.$router.push("Pdtscan"));
         }, this.Time); */
       }
      
       
    },
    methods:{
         choosefile1() {
        document.getElementById("my_file1").click();
      },
       handleImageUpload(event) {
        this.AttachmentEditId = -1
      const file = event.target.files[0];

      if (file) {
        this.selectedImage = file;
        this.previewImage = URL.createObjectURL(file);
        this.resizeImage(file);
      }
    },
    resizeImage(file) {
      var vm = this;
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // Set the canvas dimensions to the resized dimensions
          const maxWidth = 800;
          const maxHeight = 800;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;

          // Draw the image on the canvas
          ctx.drawImage(img, 0, 0, width, height);

          // Get the resized image in Base64 format
          const resizedBase64 = canvas.toDataURL('image/jpeg');
          this.resizedImage = resizedBase64;

          this.imagePURL = resizedBase64;
          this.AttachmentFile = resizedBase64
          if(this.AttachmentFile.includes("data:image/png;base64,") )
          {
              vm.AttachmentFile = this.AttachmentFile.replace("data:image/png;base64,", "");
              vm.AttachmentType = ".png"
          }
          else if(this.AttachmentFile.includes("data:image/jpeg;base64") )
          {
              vm.AttachmentFile = this.AttachmentFile.replace("data:image/jpeg;base64,", "");
              vm.AttachmentType = ".jpeg"
          }
          else if(e.target.result.includes("data:video/mp4;base64,"))
          {
              vm.AttachmentFile = this.AttachmentFile.replace("data:video/mp4;base64,","");
              vm.AttachmentType =  ".mp4"
          }
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    Print_()
    {
      this.$router.push("Printbarcode");
    },
    GetRoleSettings()
    {
       //this.IsShowLoader = true
       this.UserDetails = JSON.parse(localStorage.getItem('User'))
       axios.get(this.bURL + '/api/common/GetRoleSettingsDictionary?RoleName='+ this.UserDetails.userType)
        .then((response)  =>  {
          
             this.HideItemCostDetails = response.data.HideItemCostDetails
             if (this.HideItemCostDetails === "True") 
                this.HideItemCostDetails = true;
             else 
                this.HideItemCostDetails = false;
        }, (error)  =>  {
          console.log(error)
        })
    },
    GetCategory()
    {
      this.CategoryOptions = []
       axios.get(this.bURL + '/api/item/GetItemCategoriesSubCategories')
          .then((response)  =>  {
           for(this.i = 0;this.i<response.data.length;this.i++)
           {
             this.CategoryOptions.push(response.data[this.i].Category)
           }
           this.GetItemByBarcode()
          }, (error)  =>  {
            console.log(error)
          })
    },
    GetSubCategory(category, isNew)
    {
        axios.get(this.bURL + "/api/item/GetItemSubCategories?Category="+category)
          .then((response)  =>  {
            this.SubCategoryObject = response.data
            this.SubCategoryOptions = []
           for(this.i = 0;this.i<this.SubCategoryObject.length;this.i++)
           {
             this.SubCategoryOptions.push(this.SubCategoryObject[this.i].SubCategory)
           }
           if(isNew)
           {
           this.SubCategory = ""
           }
          }, (error)  =>  {
            console.log(error)
          })
    },
    GetItemByBarcode()
    {
        this.Barcode = localStorage.getItem('barcode')

        axios
          .get(this.bURL + "/api/item/getitembybarcode?barcode=" + this.Barcode + "&PriceGroupId=" + this.PriceGroupId )
          .then(
            (response) => {
              this.ItemObject = response.data
              this.Discountamnt =
                  (response.data.RetailRate * response.data.DiscPerc) / 100;
              this.Taxamount =((response.data.RetailRate - this.Discountamnt) *  response.data.TaxPerc) /100;
              this.CurrentStock = this.ItemObject.CurrentStock

            if(this.IsMultiBranch === true)
            {
              this.GetItemStockBranch()
            }
            this.GetItem(false)
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },

    GetItemStockBranch()
    {
        this.Barcode = localStorage.getItem('barcode')
        axios
          .get(this.bURL + "/api/Godown/GetItemStockBranch?ItemId=" + this.ItemObject.ItemId + "&Branch=" + this.BranchCode +"&isSyncOnline=true" )
          .then(
            (response) => {
              this.CurrentStock = response.data
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
    UpdateRateExcTax()
    {
        if(parseInt(this.PriceGroupId ) === 0)
        {
          this.UpdateRetailRateExcTax()
        }
        else if(parseInt(this.PriceGroupId) > 0)
        {
          this.UpdateRateByPriceGroupId()
        }
        else{
          this.SnackbarColor = 'orange'
          this.SnackbarMessege = "You cant edit rate with this price level"
          this.snackbar = true
        }
    },
    UpdateRateFinal()
    {
        if(parseInt(this.PriceGroupId ) === 0)
        {
          this.UpdateRetailRateFinal()
        }
        else if(parseInt(this.PriceGroupId ) > 0)
        {
          this.UpdateRateWithTaxByPriceGroupId()
        }
        else{
           this.SnackbarColor = 'orange'
          this.SnackbarMessege = "You cant edit rate with this price level"
          this.snackbar = true
        }
    },
    UpdateRetailRateExcTax()
    {
      this.RetailRateExcTax = parseFloat(this.RetailRateExcTax)
      this.flag = isNaN(this.RetailRateExcTax)
      if(this.flag === true)
      {
          this.RetailRateExcTax = true
           this.SnackbarColor = 'orange'
          this.SnackbarMessege = "Enter valid details"
          this.snackbar = true
          return
      }
      axios
          .get(this.bURL+"/api/item/UpdateRetailRate?Barcode="+this.Barcode +"&RetailRate="+this.RetailRateExcTax )
          .then(
            (response) => {
              this.GetItemByBarcode()
              this.RetailModalEx = false
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
    UpdateRateByPriceGroupId()
    {
      this.RetailRateExcTax = parseFloat(this.RetailRateExcTax)
      this.flag = isNaN(this.RetailRateExcTax)
      if(this.flag === true)
      {
          this.RetailRateExcTax = true
           this.SnackbarColor = 'orange'
          this.SnackbarMessege = "Enter valid details"
          this.snackbar = true
          return
      }
      axios
          .get(this.bURL+"/api/item/UpdateRateByPriceGroupId?AltUnitId="+this.ItemObject.AltUnitId +"&Rate="+this.RetailRateExcTax + "&PriceGroupId=" +this.PriceGroupId )
          .then(
            (response) => {
              this.GetItemByBarcode()
              this.RetailModalEx = false
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
    UpdateRetailRateFinal()
    {
      this.RetailRateFinal = parseFloat(this.RetailRateFinal)
      this.flag = isNaN(this.RetailRateFinal)
      if(this.flag === true)
      {
        this.RetailRateFinal = ''
         this.SnackbarColor = 'orange'
          this.SnackbarMessege = "Enter valid details"
          this.snackbar = true
          return
      }
      axios
          .get(this.bURL+"/api/item/UpdateRetailRateWithTax?Barcode="+this.Barcode +"&RetailRateWithTax="+this.RetailRateFinal )
          .then(
            (response) => {
              this.GetItemByBarcode()
              this.RetailModal = false
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },

    UpdateRateWithTaxByPriceGroupId()
    {
      this.RetailRateFinal = parseFloat(this.RetailRateFinal)
      this.flag = isNaN(this.RetailRateFinal)
      if(this.flag === true)
      {
        this.RetailRateFinal = ''
         this.SnackbarColor = 'orange'
          this.SnackbarMessege = "Enter valid details"
          this.snackbar = true
          return
      }
      axios
          .get(this.bURL+"/api/item/UpdateRateWithTaxByPriceGroupId?AltUnitId="+this.ItemObject.AltUnitId +"&RateWithTax="+this.RetailRateFinal + "&PriceGroupId=" +this.PriceGroupId )
          .then(
            (response) => {
              this.GetItemByBarcode()
              this.RetailModal = false
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },

    UpdateCost()
    {
      this.Cost = parseFloat(this.Cost)
      this.flag = isNaN(this.Cost)
      if(this.flag === true)
      {
          this.Cost = ''
           this.SnackbarColor = 'orange'
          this.SnackbarMessege = "Enter valid details"
          this.snackbar = true
          return
      }
      axios
          .get(this.bURL+"/api/item/UpdateCost?Barcode="+this.Barcode +"&Cost="+this.Cost )
          .then(
            (response) => {
              this.GetItemByBarcode()
              this.UpdateCostModal = false
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
    UpdateShelfNo()
    {
      
      if(this.ShelfNo === '')
      {
          this.Cost = ''
           this.SnackbarColor = 'orange'
          this.SnackbarMessege = "Enter valid details"
          this.snackbar = true
          return
      }
      axios
          .get(this.bURL+"/api/item/UpdateShelNoByBarcode?Barcode="+this.Barcode +"&ShelfNo="+this.ShelfNo )
          .then(
            (response) => {
              this.GetItemByBarcode()
              this.UpdateShelfNoModal = false
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
    OpenCategoryModal()
    {
      this.Category = this.ItemObject.Category
      this.GetSubCategory(this.Category,false)
      this.SubCategory = this.ItemObject.SubCategory
      this.UpdateCategoryModal=true
    },

    UpdateSubCategoryByBarcode()
    {
      
      if(this.Category === '')
      {
         this.SnackbarColor = 'orange'
          this.SnackbarMessege = "Select Category"
          this.snackbar = true
          return
      }
      if(this.SubCategory === '')
      {
         this.SnackbarColor = 'orange'
          this.SnackbarMessege = "Select subCategory"
          this.snackbar = true
          return
      }
      this.SubCategoryId = -1
      for(this.i=0;this.i<this.SubCategoryObject.length;this.i++)
      {
        if(this.SubCategoryObject[this.i].SubCategory === this.SubCategory)
        {
            this.SubCategoryId = this.SubCategoryObject[this.i].SubCategoryId
            break
        }
      }
      axios
          .get(this.bURL+"/api/item/UpdateSubCategoryByBarcode?Barcode="+this.Barcode +"&SubCategoryId="+this.SubCategoryId )
          .then(
            (response) => {
              this.GetItemByBarcode()
              this.UpdateCategoryModal = false
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
    GetAlternativeUnits(ItemId)
    {
          axios
          .get( this.bURL +
            "/api/Item/GetAlternateUnitDetails?ItemId=" +
            ItemId +
            "&IsDescendingConversion=false" +
            "&PriceGroupId=" + this.PriceGroupId 
          )
          .then(
            (response) => {
             this.AlternateUnits = response.data
             this.PriceGroupmodal=true
            },
            (error) => {
              console.log("error" + error);
              this.error = "Something went wrong..!";
            }
          );
    },
    GetGodownStockList(ItemId,CurrentStock)
    {
       if(CurrentStock  > 0)
       {
       this.Loaderdialog = true
       axios.get(this.bURL + '/api/Godown/SelectAllGodownStock?ItemId='+ItemId)
          .then((response)  =>  {
              this.GodownStockList = []
              //this.DamageGodownStockList = []
              //this.TotalStock = 0
              //this.TotalDamageStock = 0
              for(this.i=0;this.i<response.data.length;this.i++)
              {
                if(response.data[this.i].Stock.toString().includes('e'))
                {
                  response.data[this.i].Stock = 0
                }
                
                /* if(this.GodownOptions.includes(response.data[this.i].Godown))
                {
                  this.GodownStockList.push(response.data[this.i])
                  this.TotalStock += response.data[this.i].Stock
                }
                if(this.LinkedDamageGodowns.includes(response.data[this.i].Godown))
                {
                  this.DamageGodownStockList.push(response.data[this.i])
                  this.TotalDamageStock += response.data[this.i].Stock
                } */
                if(response.data[this.i].Stock > 0)
                {
                   this.GodownStockList.push(response.data[this.i])
                    this.TotalStock += response.data[this.i].Stock
                }
    
              }
              if(this.GodownStockList.length > 0)
              {
                this.GodownStockModal=true
              }
             
              this.Loaderdialog = false
          }, (error)  =>  {
            console.log(error)
          })
        }

    },


    FormatewithDecimalPlacesNew(value) {
      this.number = localStorage.getItem("symbol");
        //let val = (value / 1).toFixed(this.number).replace(".", ".");
        //return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        value = parseFloat(value);
        if(isNaN(value)  === true)
        {
          value = 0
        }
        return value.toFixed(this.number);
      
    },
     FormatewithDecimalPlacesDisc(value)
     {
          if(value === undefined || value === null)
          return

          value = value.toFixed(2)
          this.strs = value.split('.')
          if(parseFloat(this.strs[1]) > 0)
          {
            return value
          }
          else{
           return this.strs[0]
          }
     },
    SetPermission()
    {
      this.UserDetails = JSON.parse(localStorage.getItem('User'))
      axios.get ( this.bURL + '/api/common/GetFormPermission/' + this.UserDetails.userType + ',frmItem',
      {
                headers: this.headers
      })
        .then((response)  =>  {
          this.isCreatePermission = response.data[0]
          this.isReadPermission = response.data[1]
          this.isUpdatePermission = response.data[2]
          this.isDeletePermission = response.data[3]
        }, (error)  =>  {
          console.log(error)
           this.SnackbarColor = 'red'
          if(error.response === undefined)
          {
            this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
          }
          else if(error.response.data !=="")
          {
            this.SnackbarMessege = error.response.data
          }
           else if(error.response.status  === 401)
          {
             this.GlobalPasswordModal = true
          }
           else{
             this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
           }
          this.snackbar = true
        })
    },
    OpenRetailModalEx()
    {
      if(this.isUpdatePermission === true)
      {
        this.RetailModalEx=true
      }
    },
    OpenRetailModal()
    {
      if(this.isUpdatePermission === true)
      {
        this.RetailModal = true
      }
    },
    OpenUpdateCategoryModal()
    {
      if(this.isUpdatePermission === true)
      {
        this.UpdateCategoryModal=true
      }
    },
    OpenUpdateShelfNoModal()
    {
      if(this.isUpdatePermission === true)
      {
        this.UpdateShelfNoModal=true
      }
    },
    OpenUpdateCostModal()
    {
      if(this.isUpdatePermission === true)
      {
        this.UpdateCostModal=true
      }
    },
    SaveItemImage()
    {
      this.ItemObjectToSave.Attachments = this.Attachments
        axios.put(this.bURL+'/api/Item/' + this.ItemObjectToSave.ItemId,this.ItemObjectToSave)
          .then((response)  =>  {
            this.AttachmentModal = false
           this.snackbar = false
           this.Loaderdialog = false
            this.SnackbarColor = 'green'
           this.SnackbarMessege =this.$t(`menu.SavedSuccessfully`)
           this.Loaderdialog = false

          }, (error)  =>  {
             this.snackbar = false
              this.SnackbarColor = 'red'
           this.SnackbarMessege =this.$t(`menu.failed`)
             this.Loaderdialog = false
            console.log(error)

          })
    },
    GetItem(IsSaveImage)
    {
      this.Loaderdialog = true
      axios.get ( this.bURL +'/api/Item/'+this.ItemObject.ItemId)
        .then((response)  =>  {
          this.ItemObjectToSave = response.data
          if(IsSaveImage  === true)
          {
              this.SaveItemImage()
          }
          else{
            this.Attachments = response.data.Attachments
            this.Loaderdialog = false
            if(this.Attachments.length > 0)
            this.FileURL = this.Attachments[0].FileURL
          }
          
        }, (error)  =>  {
          console.log(error)
        })
    },
    AddItemImage()
    {
      this.obj = {
          "AttachmentId":-1,
          "Caption": "",
           "ContentB64": this.AttachmentFile,
          "FileExtension": this.AttachmentType,
          "FileURL": "data:image/png;base64," + this.AttachmentFile,
          "ParentId": 0,
          "ParentName": "",
          "ParentType": "",
          "Remarks": ""
        }
        this.Attachments.push(this.obj)
        if(this.Attachments.length === 1)
        {
          this.FileURL = "data:image/png;base64," + this.AttachmentFile
        }
        this.AttachmentModal = false
        this.GetItem(true)
    },
    EditItemImage(item,i)
    {
      this.AttachmentEditId = i
      this.AttachmentId = item.AttachmentId
      this.imagePURL = item.FileURL
      this.AttachmentModal = true
    },
    DeleteItemImage()
    {
         this.DeleteItemImageModal =  true
    },
    ExcecuteDeleteItem()
    {
        this.Attachments.splice(this.AttachmentEditId,1)
        this.DeleteItemImageModal =  false
        this.AttachmentModal = false
        this.GetItem(true)
    },
    ClearItemImage()
    {
       this.AttachmentEditId = -1
       this.AttachmentFile =  ""
       this.AttachmentType = ""
       this.imagePURL = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL_nkjk3ZfgDytXi0IAHbpW1PnkEf8TpGwsQ2FnEzoWLc7_Z5VFQnN86GJX1drBJh7ysY&usqp=CAU"
    },
     OpenItemImageModal()
    {
       this.AttachmentEditId = -1
       this.AttachmentFile =  ""
       this.AttachmentType = ""
       this.imagePURL = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSL_nkjk3ZfgDytXi0IAHbpW1PnkEf8TpGwsQ2FnEzoWLc7_Z5VFQnN86GJX1drBJh7ysY&usqp=CAU"
       this.AttachmentModal = true
    },
    DownloadItemImage()
    {

    if (this.IsNativeFlutterApp === true) {
          this.OpenPDFFlutter(this.Attachments[this.AttachmentEditId].FileURL)
      }
      else {
         window.open(this.Attachments[this.AttachmentEditId].FileURL, "_blank");
      }

      //window.open(this.ItemImages[this.AttachmentEditId].Image, "_blank");
    },
    
    }
  };
  </script>
  <style  scoped>

 [class~=cover-container],
[class~=cover-item] {
	height: 100%;
}

[class~=cover-container] {
	width: 100%;
}

[class~=cs],
[class~=cover-container] {
	white-space: nowrap;
}

[class~=cover-container] {
	overflow-x: scroll;
}

[class~=cover-container] {
	overflow-y: hidden;
}

[class~=cover-item] {
	font-size: 2.5vw;
}

[class~=cover-item] {
	position: relative;
}

[class~=cs],
[class~=cover-item] {
	display: inline-block;
}

[class~=cover-item] {
	margin-left: 6pt;
}

[class~=cover-item] {
	margin-bottom: .083333333in;
}

[class~=cover-item] {
	margin-right: 6pt;
}

[class~=cover-item] {
	margin-top: .083333333in;
}

[class~=cover-item] {
	box-shadow: .020833333in .125pc 3pt #bbb;
}

[class~=cover-item] {
	border-top-right-radius: .25pc;
}

[class~=cover-item] {
	width: 60pt;
}

[class~=cover-item] {
	vertical-align: bottom;
}

[class~=cover-item] {
	background-position: top left;
}

[class~=cover-item] {
	background-repeat: no-repeat;
}

[class~=cover-item] {
	background-size: cover;
}

[class~=cs] {
	width: 100%;
}

[class~=cs] {
	overflow: hidden !important;
}

[class~=cs] {
	text-overflow: ellipsis;
}
 .cs1{
   font-size: 15px;
 }
 </style>
